export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ18.59c36281.mp3";